export default __webpack_public_path__ + "static/media/BecomeFodrixographerLatest.9a4d7e2e.webp";